import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-inbox-icon',
  standalone: true,
  templateUrl: './inbox-icon.component.html',
  styleUrls: ['./inbox-icon.component.scss']
})
export class InboxIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
